define('widgets/files',[
	'jquery',
	'lib/jquery-ui/widget'
], function ($) {

	return $.widget('muse.files', {

		options: {
		},

		_create: function () {

			this.$input = this.element.find('input');
			this.$value = this.element.find('.value');

			this._on(this.$input, {
				change: 'onChange'
			});

			return this._super();

		},

		onChange: function () {

			var files = this.$input[0].files,
				value = '';

			if (files) {

				files.length && (value = files.length > 1 ? files.length + ' files' : files[0].name);

			} else {

				value = this.$input.val();
				value = value.match(/[^\/\\]+$/);

			}

			this.$value.text(value);

		}

	});

});
